import request from '@/utils/request'
import qs from 'qs'
// const MOCK_URL: string = 'http://localhost:3000' // mock
const MOCK_URL: string = ''
// ****************** IOS *********************
// IOS - 列表
export const getIosList = (data: any) =>
  request({
    url: `${MOCK_URL}/ios/info`,
    method: 'get',
    params: data
  })

// IOS - 应用来源
export const getIosSource = () =>
  request({
    url: `/ios/source`,
    method: 'get'
  })
// 应用状态
export const getAppStatus = (data?: { ids: string }) =>
  request({
    url: `/app/status`,
    method: 'get',
    params: data
  })
// IOS - 应用详情页
export const getIosAppDetail = (id: number) =>
  request({
    url: `/ios/detail/${id}`,
    method: 'get'
  })
// 应用新增ios id
export const getNewAppId = () =>
  request({
    url: '/ios/entityId',
    method: 'get'
  })
// IOS-应用更新记录
export const getIosAppLogs = (id: number) =>
  request({
    url: `/ios/updateLog/${id}`,
    method: 'get'
  })

// IOS - 多语言种类信息
export const getIosLangInfo = (data: any) =>
  request({
    url: `/ios/translation`,
    method: 'get',
    params: data
  })

// IOS - 获取编辑页的内容
export const getIosAppInfo = (data: any) =>
  request({
    url: `/v2/ios/edit`,
    method: 'get',
    params: data
  })

// IOS - 新增/修改
export const addEditIosApp = (data: any) =>
  request({
    url: '/v2/ios/saveData',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })

// IOS - 多语言新增/修改
export const addEditIosLang = (data: IIOsLangAddEdit) =>
  request({
    url: '/ios/translation',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })

// IOS - 获取文件管理列表
export const getIosFileList = (id: number, data: any) =>
  request({
    url: `/ios/fileList/${id}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: data
  })

export const deleteIosApp = (data: any) =>
  request({
    url: '/v2/ios/deleteOp',
    method: 'post',
    data: qs.stringify(data)
  })

// ****************** Android *********************
// Android - 列表
export const getAndroidList = (data: any) =>
  request({
    url: `/android/info_list`,
    method: 'get',
    params: data
  })

// Android - 应用来源
export const getAndroidSource = () =>
  request({
    url: `/android/source`,
    method: 'get'
  })
// 应用新增andorid id
export const getNewAppAndoridId = () =>
  request({
    url: '/android/entityId',
    method: 'get'
  })
// Android - 应用详情页
export const getAndroidAppDetail = (id: number) =>
  request({
    url: `/android/details/${id}`,
    method: 'get'
  })

// Android-应用更新记录列表
export const getAndroidAppLogs = (data: any) =>
  request({
    url: `/android/app_record_list`,
    method: 'get',
    params: data
  })

// Android-应用更新记录
export const getAndroidAppLog = (id: number) =>
  request({
    url: `/android/versionLog/${id}`,
    method: 'get'
  })

// Android - 多语言种类信息
export const getAndroidLangInfo = (data: any) =>
  request({
    url: `/android/language/list`,
    method: 'get',
    params: data
  })

// Android - 获取编辑页的内容
export const getAndroidAppInfo = (params: any) =>
  request({
    url: '/v2/android/edit',
    method: 'get',
    params
  })

// Android - 新增/修改
export const addEditAndroidApp = (data: any) =>
  request({
    url: '/v2/android/saveData',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })

// Android - 多语言新增/修改
export const addEditAndroidLang = (data: IAndroidLangAddEdit) =>
  request({
    url: '/android/language/option',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })

// Adroid - 获取文件管理列表
export const getAdroidFileList = (id: number, data: any) =>
  request({
    url: `/android/fileList/${id}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: data
  })

export const deleteAndroidApp = (data: any) =>
  request({
    url: '/v2/android/deleteOp',
    method: 'post',
    data: qs.stringify(data)
  })
